import CategoriesComponent from '../components/categories/categories'

const Categories = () => <CategoriesComponent />

export default Categories;